import { Component } from '@angular/core';
import { AlertController, NavParams, ViewController } from 'ionic-angular';

import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { TomadaDeContaService } from '../../../../providers/tce-service';

@Component({
    selector: 'page-modal-pv-tce',
    templateUrl: 'modal-pv-tce.html'
})
export class ModalPreVisualizarTcePage {
    titulo: any;
    isJurisdicionado: any;
    listaDados: any;
    listaDadosBaixa: any = [];
    listaDadosReincidencia: any = [];
    listaDadosOutros: any = [];
    dataGeracao: any;
    loading: boolean = true;
    shownGroup: any = [];

    constructor(private viewCtrl: ViewController,
        public navParams: NavParams,
        public tceService: TomadaDeContaService,
        public alertCtrl: AlertController,
        public gestaoPcaService: GestaoPcaService) {

        this.dataGeracao = new Date();

        this.listarDados();
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }

    listarDados() {
        this.tceService.obterPreviewCertificado().subscribe(
            data => {
                this.listaDados = data;

                this.loading = false;
            }, error => {
                console.log("erro: " + error);
                this.loading = false;
            }
        );
    }

    //  #region Métodos do Accordion
    toggleGroup(group) {
        if (this.isGroupShown(group)) {
            let index = this.shownGroup.indexOf(group);
            this.shownGroup.splice(index, 1);
        } else {
            this.shownGroup.push(group);
        }
    }

    isGroupShown(group) {
        return this.shownGroup.indexOf(group) != -1;
    };

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    formatarPorcentagem(valor) {
        return valor.toString().replace('.', ',') + "%";
    }

    calcularDiferencaData(item) {
        const year = item.dtLimite.substr(6, 4);
        const month = item.dtLimite.substr(3, 2);
        const day = item.dtLimite.substr(0, 2);
        const date = new Date(year, month, day);

        var date1 = new Date(date);
        var date2 = new Date();

        var timeDiff = Math.abs(date2.getTime() - date1.getTime());

        item.nmDiasAtrasados = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 30;

        return item.nmDiasAtrasados;
    }
}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-pre-visualizacao/tce/modal-pv-tce.ts